﻿@if (gridRows) {
  <div id="rdo-grid">
    <div class="ui-table-missing-scrollable-header"></div>
    <p-table #rdoExpandedGrid
      [value]="gridRows"
      [dataKey]="dataKey"
      [styleClass]="'rdo-ui-table'"
      [rowHover]="false"
      [sortMode]="'single'"
      [sortField]="sorting.sortField"
      [sortOrder]="sorting.sortOrder"
      [scrollable]="true"
      [scrollHeight]="scrollHeight"
      [frozenValue]="frozenGridRows"
      [frozenWidth]="frozenWidth"
      [columns]="scrollableColumns"
      [frozenColumns]="frozenColumns"
      [customSort]="true"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      (onRowExpand)="onRowExpand($event.data)"
      (onRowCollapse)="onRowCollapse($event.data)"
      (onSort)="changeSort($event)"
      >
      <ng-template #breadcrumbActions>
        @if (showColumnSelector && !useProductTypeColumnSelector) {
          <rdo-column-selector
            [size]="'md'"
            [gridConfig]="gridConfig"
            (visibilityChanged)="saveVisibility()"
            (downloadExcelClick)="downloadExcelClick.next(gridConfig)">
          </rdo-column-selector>
        }
        @if (showColumnSelector && useProductTypeColumnSelector) {
          <rdo-column-selector-product-type
            [size]="'md'" [gridConfig]="gridConfig" (visibilityChanged)="saveVisibility()"
            (downloadExcelClick)="downloadExcelClick.next(gridConfig)">
          </rdo-column-selector-product-type>
        }
      </ng-template>
      <ng-template pTemplate="colgroup" let-columns>
        @for (group of columns; track group) {
          @for (column of group.columns; track column) {
            <colgroup>
            <col [style.width]="getWidthStyle(column)" />
          </colgroup>
        }
      }
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (group of columns; track group) {
          <th [style.width]="getColGroupWidth(group)"
            [attr.colspan]="group.columns.length" [class.expandable]="group.expandable"
            [class.group-end]="isGroupEnd(group)" id="{{group.title | rdoPathToId}}"
            [ngStyle]="group.headerStyle">
            <div data-toggle="tooltip" htmlTooltip="{{getGroupTooltip(group)}}"
              [attr.title]="getGroupTooltip(group) ? null : translate(group.title)">{{translate(group.title)}}
            </div>
            @if (!group.locked) {
              <a (click)="toggleColumnVisibility(group)"
                title="{{'main.core.tables.common.hide_column_group' | translate}}">
                <span class="fa fa-lg fa-times-circle pull-right"></span>
              </a>
            }
          </th>
        }
      </tr>
      <tr>
        @for (group of columns; track group) {
          @for (column of group.columns; track column; let columnIndex = $index) {
            <th id="{{column.sortColumn}}"
              [pSortableColumn]="filterSortableColumns(column)" [ngStyle]="column.headerStyle"
              [style.width.px]="column.width || 110" [class.group-end]="isHeaderGroupEnd(group, column)"
              class="ellipsed-th">
              <div class="ellipsed-div">
                <!-- [ngStyle]="{'line-height': (!group.title) || !allowDoubleHeader ? '2.9em' : 'unset' }" -->
                <div htmlTooltip="{{getColumnTooltip(column)}}"
                  [attr.title]="getColumnTooltip(column) ? null : translate(column.title)"
                  [attr.data-column]="translate(column.title)"
                  [ngStyle]="{'line-height': !allowDoubleHeader ? '2.9em' : 'unset' }">{{(column |
                rdoEllipsis:column.renderedWidth).processedTitle}}</div>
                <p-sortIcon [field]="column.sortColumn"></p-sortIcon>
              </div>
            </th>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="frozenrows" let-rowData let-columns="columns">
      <tr class="frozen-row">
        @for (group of columns; track group) {
          @for (column of group.columns; track column) {
            <td id="header-{{column.sortColumn}}-cell"
              [ngClass]="rowData[column.sortColumn].class" [ngStyle]="rowData[column.sortColumn].style"
              [style.width]="rowData[column.sortColumn].width"
              [class.group-end]="isCellGroupEnd(group, column)"
              title="{{handleValue(rowData[column.sortColumn].value)}}">
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && isBool(rowData[column.sortColumn].value) && rowData[column.sortColumn].value) {
                <i
                class="fa fa-check"></i>
              }
              @if (rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                  [routerLink]="rowData[column.sortColumn].linkDsl">{{rowData[column.sortColumn].value |
                translate}}</a>
              }
              @if (rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                  href="{{rowData[column.sortColumn].href}}">{{rowData[column.sortColumn].value |
                translate}}</a>
              }
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && !isBool(rowData[column.sortColumn].value)) {
                <span id="header-{{column.sortColumn}}-cell-text"
                  >
                {{translate(rowData[column.sortColumn].value)}}</span>
              }
            </td>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="frozenbody" let-rowData let-rowIndex="rowIndex" let-expanded="expanded"
      let-columns="columns">
      <tr class="clickable-row" (mouseenter)="onMouseEnter(rowData)" (mouseleave)="onMouseLeave(rowData)"
        [pRowToggler]="rowData" [class.row-hover]="rowData.hover">
        @for (group of columns; track group) {
          @for (column of group.columns; track column; let columnIndex = $index) {
            @if (columnIndex === 0) {
              <td id="detail-{{column.sortColumn}}-{{rowIndex}}"
                [ngClass]="rowData[column.sortColumn].class" [ngStyle]="rowData[column.sortColumn].style"
                [style.width]="rowData[column.sortColumn].width"
                [class.group-end]="isCellGroupEnd(group, column)"
                title="{{handleValue(rowData[column.sortColumn].value)}}">
                @if (!rowData.childLoading) {
                  <i
                  [ngClass]="expanded ? 'fa fa-fw fa-angle-down' : 'fa fa-fw fa-angle-right'"></i>
                }
                @if (rowData.childLoading) {
                  <i class="fa fa-fw fa-circle-o-notch fa-spin"></i>
                }
                <span>{{rowData[column.sortColumn].value}}</span>
              </td>
            }
            @if (columnIndex !== 0) {
              <td id="detail-{{column.sortColumn}}-{{rowIndex}}"
                [ngClass]="rowData[column.sortColumn].class" [ngStyle]="rowData[column.sortColumn].style"
                [style.width]="rowData[column.sortColumn].width"
                [class.group-end]="isCellGroupEnd(group, column)"
                title="{{handleValue(rowData[column.sortColumn].value)}}">
                @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && isBool(rowData[column.sortColumn].value) && rowData[column.sortColumn].value) {
                  <i
                  class="fa fa-check"></i>
                }
                @if (rowData[column.sortColumn].linkDsl) {
                  <a
                    (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                  [routerLink]="rowData[column.sortColumn].linkDsl">{{rowData[column.sortColumn].value}}</a>
                }
                @if (rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl) {
                  <a
                    (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                  href="{{rowData[column.sortColumn].href}}">{{rowData[column.sortColumn].value}}</a>
                }
                @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && !isBool(rowData[column.sortColumn].value)) {
                  <span
                  >{{rowData[column.sortColumn].value}}</span>
                }
              </td>
            }
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-index="rowIndex" let-columns="columns" let-rowIndex="rowIndex">
      <tr class="clickable-row" (mouseenter)="onMouseEnter(rowData)" (mouseleave)="onMouseLeave(rowData)"
        [pRowToggler]="rowData" [class.row-hover]="rowData.hover">
        @for (group of columns; track group) {
          @for (column of group.columns; track column) {
            <td id="detail-{{column.sortColumn}}-{{index}}"
              [ngClass]="rowData[column.sortColumn].class" [ngStyle]="rowData[column.sortColumn].style"
              [style.width]="rowData[column.sortColumn].width"
              [class.group-end]="isCellGroupEnd(group, column)"
              title="{{handleValue(rowData[column.sortColumn].value)}}">
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && isBool(rowData[column.sortColumn].value) && rowData[column.sortColumn].value) {
                <i
                class="fa fa-check"></i>
              }
              @if (rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                [routerLink]="rowData[column.sortColumn].linkDsl">{{translate(rowData[column.sortColumn].value)}}</a>
              }
              @if (rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl) {
                <a
                  (click)="clickCellLink(rowData[column.sortColumn].config, rowData.raw)"
                href="{{rowData[column.sortColumn].href}}">{{translate(rowData[column.sortColumn].value)}}</a>
              }
              @if (!rowData[column.sortColumn].href && !rowData[column.sortColumn].linkDsl && !isBool(rowData[column.sortColumn].value)) {
                <span
                >{{translate(rowData[column.sortColumn].value)}}</span>
              }
            </td>
          }
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
      @for (childRowData of rowData.childRows; track childRowData) {
        <tr class="expansion-row"
          (mouseenter)="onMouseEnter(childRowData)" (mouseleave)="onMouseLeave(childRowData)"
          [class.row-hover]="childRowData.hover">
          @for (group of columns; track group) {
            @for (column of group.columns; track column) {
              <td id="detail-{{column.sortColumn}}-{{index}}"
                [ngClass]="childRowData[column.sortColumn].class"
                [ngStyle]="childRowData[column.sortColumn].style"
                [style.width]="childRowData[column.sortColumn].width"
                [class.group-end]="isCellGroupEnd(group, column)"
                title="{{handleValue(rowData[column.sortColumn].value)}}">
                @if (!childRowData[column.sortColumn].href && !childRowData[column.sortColumn].linkDsl && isBool(childRowData[column.sortColumn].value) && childRowData[column.sortColumn].value) {
                  <i
                  class="fa fa-check"></i>
                }
                @if (childRowData[column.sortColumn].linkDsl) {
                  <a
                    (click)="clickCellLink(childRowData[column.sortColumn].config, childRowData.raw, rowData.raw)"
                  [routerLink]="childRowData[column.sortColumn].linkDsl">{{translate(childRowData[column.sortColumn].value)}}</a>
                }
                @if (childRowData[column.sortColumn].href && !childRowData[column.sortColumn].linkDsl) {
                  <a
                    (click)="clickCellLink(childRowData[column.sortColumn].config, childRowData.raw, rowData.raw)"
                  href="{{childRowData[column.sortColumn].href}}">{{translate(childRowData[column.sortColumn].value)}}</a>
                }
                @if (!childRowData[column.sortColumn].href && !childRowData[column.sortColumn].linkDsl && !isBool(childRowData[column.sortColumn].value)) {
                  <span
                  >{{translate(childRowData[column.sortColumn].value)}}</span>
                }
              </td>
            }
          }
        </tr>
      }
    </ng-template>
  </p-table>
  <p-paginator #gridPaginator id="gridPaginator" styleClass="rdo-paginator" [(first)]="paging.first"
    [rowsPerPageOptions]="[10,20,50]" [pageLinkSize]="10" [rows]="paging.pageSize" [totalRecords]="totalCount"
    (onPageChange)="onPage($event)" [alwaysShow]="alwaysShowPager">
  </p-paginator>
</div>
}
